import React, { useState } from "react"
import {
  addressItemAddress,
  addressItemName,
  addressItemTitle,
  addressItemContacts,
  addressItemTel,
  addressItemMail,
  addressItemMailMobile,
  addressItemTooltip,
  addressItemTooltipMobile,
  addressMore,
  pasteButton,
  pasteButtonImg,
  hiddenInfoBulle,
} from "../map-carnet-adresse.module.scss"
import { AddressTitle, StyledLink } from "./address-content-styled"
import PropTypes from "prop-types"
import TransitionFade from "../../../transition-fade"
import Obfuscate from "react-obfuscate"
import paste from "../../../../images/paste.png"

const AddressContent = ({ address }) => {
  const [emailVisible, setEmailVisible] = useState(false)
  const [isInfoBulleVisible, setIsInfoBulleVisible] = useState(true)

  if (typeof document !== `undefined`) {
    document.addEventListener("keyup", (event) => {
      if (event.key === "Escape") {
        setIsInfoBulleVisible(!isInfoBulleVisible)
      }
    })
  }

  return (
    <>
      <TransitionFade className={addressItemName} link={address.path.alias}>
        <AddressTitle className={addressItemTitle}>
          {address.title}
        </AddressTitle>
        <div className={addressItemAddress}>
          <div>{address.field_adresse?.address_line1}</div>
          <div>{address.field_adresse?.address_line2}</div>
          <div>
            {address.field_adresse?.postal_code}{" "}
            {address.field_adresse?.locality}
          </div>
        </div>
      </TransitionFade>
      <div className={addressItemContacts}>
        {!address.field_mail ? null : (
          <>
            <Obfuscate
              obfuscateChildren={false}
              email={address.field_mail}
              className={
                addressItemMail +
                " " +
                (!isInfoBulleVisible ? hiddenInfoBulle : "")
              }
            >
              Envoyer un email
              <div className={addressItemTooltip}>
                <Obfuscate element="span">{address.field_mail}</Obfuscate>
                <button
                  className={pasteButton}
                  onClick={(event) => {
                    event.preventDefault()
                    navigator.clipboard.writeText(address.field_mail)
                    alert("Email copié avec succès")
                  }}
                >
                  <img
                    alt="copiercoller"
                    className={pasteButtonImg}
                    src={paste}
                  />
                </button>
              </div>
            </Obfuscate>
            <p
              role="button"
              onClick={() => setEmailVisible(true)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  setEmailVisible(true)
                }
              }}
              tabIndex={0}
              className={addressItemMailMobile}
              aria-label={"Dévoiler l'adresse email"}
              aria-expanded={emailVisible}
            >
              Envoyer un email
              {emailVisible === true && (
                <a
                  href={`mailto:${address.field_mail}`}
                  style={{ textAlign: "left" }}
                  className={addressItemTooltipMobile}
                >
                  {address.field_mail}
                </a>
              )}
            </p>
          </>
        )}
        {address.field_telephone && (
          <Obfuscate tel={address.field_telephone} className={addressItemTel} />
        )}
      </div>
      <StyledLink className={addressMore} link={address.path.alias}>
        Plus d&apos;infos
      </StyledLink>
    </>
  )
}

AddressContent.propTypes = {
  address: PropTypes.object.isRequired,
}

export default AddressContent
